export const NUMBER_OF_SHOWN_FILTER_ITEMS = 8;

/**
 * ROW_STEP - количество рядов карточек, которые отображаем в каталоге
 * при клике на "показать еще" показывается еще {ROW_STEP} рядов
 */

export const ROW_STEP = 10;
